import { render, staticRenderFns } from "./UnfixedStock.vue?vue&type=template&id=1e8cef32&scoped=true&"
import script from "./UnfixedStock.vue?vue&type=script&lang=ts&"
export * from "./UnfixedStock.vue?vue&type=script&lang=ts&"
import style0 from "./UnfixedStock.vue?vue&type=style&index=0&id=1e8cef32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8cef32",
  null
  
)

export default component.exports